export const LOAD_CUSTOMERS = 'customers/LOAD_CUSTOMERS';
export const LOAD_CUSTOMERS_SUCCESS = 'customers/LOAD_CUSTOMERS_SUCCESS';
export const LOAD_CUSTOMERS_ERROR = 'customers/LOAD_CUSTOMERS_ERROR';
export const SAVE_CUSTOMER_REQUEST = 'customers/SAVE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_REQUEST = 'customers/DELETE_CUSTOMER_REQUEST';
